'use client'

import { LocalizedMonthPicker } from '@/components/LocalizedMonthPicker'
import { useTranslation } from 'react-i18next'
import { Container } from './Container'

type MonthYearFilterProps = {
  name: string
  title: string
  value: Date | undefined
  setValue: React.Dispatch<React.SetStateAction<Date | undefined>>
}

/**
 * Single month-start filter (e.g. a CRT period). The picker never emits `undefined`, so clearing
 * comes from the `Container` reset link: it stages `undefined`, which flows straight back into
 * `value` and restores the placeholder. `value` must therefore be forwarded unconditionally — a
 * fallback date here would make the filter impossible to clear.
 */
export function MonthYearFilter(props: MonthYearFilterProps) {
  const { t } = useTranslation('common')
  const hasValue = props.value !== undefined

  const handleReset = () => {
    props.setValue(undefined)
  }

  return (
    <Container
      isResetVisible={hasValue}
      onReset={handleReset}
      hasOptionsSelected={hasValue}
      title={props.title}
    >
      <LocalizedMonthPicker
        value={props.value}
        onValueChange={props.setValue}
        placeholder={t('monthYearPicker.selectMonth')}
      />
    </Container>
  )
}
